import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { applyPriceChange } from "../api/applyPriceChange";

export const useApplyPriceChange = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ changeId, companyId }) => applyPriceChange(changeId, companyId),
    onSuccess: () => {
      toast.success("Price change applied successfully!");
      queryClient.invalidateQueries({ queryKey: ["pendingPriceChanges"] });
      queryClient.invalidateQueries({ queryKey: ["subscriptionDetails"] });
      queryClient.invalidateQueries({ queryKey: ["allSubscriptions"] });
    },
    onError: (error) => {
      toast.error(error.message || "Failed to apply price change.");
    },
  });
};

